export default __webpack_public_path__ + "static/media/airbnb.874ec1fc.png";